<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon"><i class="pi pi-pencil"></i></div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">تعديل السنة الدراسية</h1>
        <p class="form-page-header__subtitle" v-if="year">{{ year.name }}</p>
      </div>
      <div v-if="year" class="form-page-header__badges">
        <span class="status-badge" :class="year.is_active ? 'status-badge--accepted' : 'status-badge--blocked'">
          {{ year.is_active ? 'مفعّلة' : 'معطّلة' }}
        </span>
        <span class="badge-pill">{{ stageLabel(year.stage) }}</span>
      </div>
      <div v-if="year" class="form-page-header__actions">
        <router-link :to="`/academic-years/${year.id}/messages`" class="btn btn-secondary text-white">
          <i class="pi pi-envelope me-1"></i> رسائل الحجز
        </router-link>
      </div>
    </div>

    <Loading v-if="loading" />
    <div v-else-if="!year" class="ds-container">
      <div class="empty-state empty-state--card">
        <div class="empty-state__icon"><i class="pi pi-exclamation-triangle"></i></div>
        <h3 class="empty-state__title">لم يتم العثور على السنة الدراسية</h3>
        <p class="empty-state__desc">ربما تم حذف هذه السنة أو الرابط غير صحيح.</p>
        <router-link to="/academic-years" class="ds-btn ds-btn--primary empty-state__action">رجوع للسنوات الدراسية</router-link>
      </div>
    </div>
    <AcademicYearForm v-else :year="year" />
  </div>
</template>

<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import Loading from '@/components/global/loading.vue';
import AcademicYearForm from './AcademicYearForm.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: 'AcademicYearEdit',
  components: { Breadcrumb, Loading, AcademicYearForm },
  data() {
    return {
      loading: true,
      year: null,
      breadcrumbs: [
        { name: 'الرئيسية', path: '/' },
        { name: 'السنوات الدراسية', path: '/academic-years' },
        { name: 'تعديل', path: '#' },
      ],
    };
  },
  methods: {
    stageLabel(stage) {
      return { primary: 'المرحلة الابتدائية', prep: 'المرحلة الإعدادية', secondary: 'المرحلة الثانوية' }[stage] || '';
    },
  },
  async mounted() {
    const gradeStore = useGradeStore();
    if (!gradeStore.allGrades.length) await gradeStore.fetchAllGrades();
    this.year = gradeStore.allGrades.find(g => String(g.id) === String(this.$route.params.id)) ?? null;
    this.loading = false;
  },
};
</script>
